<div class="ui icon message message-container">
    <ng-container [ngSwitch]="confirmationState">
        <ng-container *ngSwitchCase="'change-attendees'">
            <wizard-change-attendees-confirmation
                [availabilityUsers]="availabilityUsers"
                [availabilityTypeText]="availabilityTypeText"
                [currentUser]="currentUser"
                [vipContacts]="vipContacts"
                [isUpdatingMeeting]="isUpdatingMeeting"
                [originalContacts]="originalContacts"
                [selectedContacts]="selectedContacts"
                [taskStatus]="wizardService.responseData?.taskStatus"
            >
            </wizard-change-attendees-confirmation>
        </ng-container>
        <ng-container *ngSwitchCase="'booking'">
            <wizard-booking-confirmation
                [availabilityUsers]="availabilityUsers"
                [availabilityTypeText]="availabilityTypeText"
                [currentUser]="currentUser"
                [vipContacts]="vipContacts"
                [isUpdatingMeeting]="isUpdatingMeeting"
                [selectedContacts]="selectedContacts"
                [timezone]="timezone"
            >
            </wizard-booking-confirmation>
        </ng-container>
        <div class="wrapper" *ngSwitchDefault>
            <div class="content">
                <ng-container *ngIf="isUpdatingMeeting; else displayDefaultConfirmation">
                    <div class="blue header">
                        Ok {{ currentUser.name }}, I'm ready to send out the updated invitations!
                    </div>

                    <p class="content__body">
                        I'll email the attendees and ask them to select a new
                        <ng-container *ngTemplateOutlet="timesAndDatesTemplate"></ng-container>
                    </p>

                    <p>I'll let you know once the meeting is booked. Click send, and I'll mail those invites out!</p>
                </ng-container>

                <ng-template #displayDefaultConfirmation>
                    <div class="blue header">Invites are ready to send</div>
                    <p class="header__subtitle">
                        Your meeting assistant ({{ currentUser.avatar }}) can send the invites for you OR you can
                        generate a private invite link to send on your own.
                    </p>

                    <p class="content__body">
                        Either way, invitees will be able to select a
                        <ng-container *ngTemplateOutlet="timesAndDatesTemplate"></ng-container>
                    </p>

                    <p>Calendar confirmations will be sent once the meeting is booked.</p>

                    <div class="ui list">
                        <div class="ui tiny header">Invitees:</div>
                        <ng-container *ngFor="let contact of selectedContacts">
                            <div class="item">
                                {{ contact.name }}
                                <span class="light"
                                    >({{ contact.defaultEmail || (contact.email && contact.email[0]) }})</span
                                >
                                <div *ngIf="contact | checkIsVIP: vipContacts" class="vip">
                                    <i class="ui star icon"></i>
                                    <span class="vip__tooltip">VIP</span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>

                <ng-template #timesAndDatesTemplate>
                    <span class="strong">{{ wizardService.options.meetingLength | durationTime }} meeting</span>
                    time based on {{ availabilityTypeText }} availability
                    <span class="strong"
                        >between {{ wizardService.options.dateStart | date: 'MMMM d' }} and
                        {{ wizardService.options.dateEnd | date: 'MMMM d' }}</span
                    >.
                </ng-template>

                <div *ngIf="availabilityUsers?.length" class="ui list">
                    <div class="ui tiny header">
                        This is a {{ availabilityTypeText }} meeting, based on the availability of:
                    </div>
                    <ng-container *ngFor="let member of availabilityUsers">
                        <div class="item">
                            {{ member.name }}
                            <span class="light">({{ member.defaultEmail || member.email[0] }})</span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <img class="ui medium image" src="/assets/images/time-selection.svg" />
        </div>
    </ng-container>
</div>
